import { c as _c } from "react/compiler-runtime";
import { GetStaticProps } from 'next';
import { Roots } from 'next-roots/context';
import WhistleblowingRoot, * as __root from 'roots/whistleblowing';
function WhistleblowingPage(pageProps) {
  const $ = _c(2);
  let t0;
  if ($[0] !== pageProps) {
    t0 = <WhistleblowingRoot {...pageProps} />;
    $[0] = pageProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
WhistleblowingPage.getRoots = (): Partial<Roots> => ({
  currentLocale: 'hu',
  currentRoot: 'whistleblowing',
  currentRule: {
    "key": "hu:whistleblowing",
    "href": "/whistleblowing"
  },
  currentMeta: {
    "key": "hu:whistleblowing",
    "data": {}
  },
  rules: [{
    "key": "hu:home",
    "href": "/"
  }, {
    "key": "hu:cenik",
    "href": "/pricing"
  }, {
    "key": "hu:chci-aplikaci",
    "href": "/get-the-app"
  }, {
    "key": "hu:css-program",
    "href": "/css-program"
  }, {
    "key": "hu:dokumenty/index",
    "href": "/documents"
  }, {
    "key": "hu:dokumenty/generated/informacni-memorandum",
    "href": "/dokumenty/generated/informacne-memorandum"
  }, {
    "key": "hu:dokumenty/generated/post",
    "href": "/dokumenty/generated/[post]"
  }, {
    "key": "hu:doporucte-nas",
    "href": "/doporucte-nas"
  }, {
    "key": "hu:dobirka",
    "href": "/dobirka"
  }, {
    "key": "hu:dotaznik",
    "href": "/dotaznik"
  }, {
    "key": "hu:informacni-memorandum",
    "href": "/information-memorandum"
  }, {
    "key": "hu:investuj-pri-nakupovani",
    "href": "/investuj-pri-nakupovani"
  }, {
    "key": "hu:jak-zaplatit",
    "href": "/jak-zaplatit"
  }, {
    "key": "hu:kariera/index",
    "href": "/career"
  }, {
    "key": "hu:kariera/volne-pozice",
    "href": "/career/vacant-positions"
  }, {
    "key": "hu:kariera/detail",
    "href": "/career/[job]"
  }, {
    "key": "hu:caste-dotazy/index",
    "href": "/faq"
  }, {
    "key": "hu:caste-dotazy/category",
    "href": "/faq/[category]"
  }, {
    "key": "hu:caste-dotazy/question",
    "href": "/faq/[category]/[question]"
  }, {
    "key": "hu:karta",
    "href": "/karta"
  }, {
    "key": "hu:kde-nakupovat",
    "href": "/where-to-shop"
  }, {
    "key": "hu:kontakty",
    "href": "/contact"
  }, {
    "key": "hu:kontokorent",
    "href": "/kontokorent"
  }, {
    "key": "hu:kreditni-karta",
    "href": "/kreditni-karta"
  }, {
    "key": "hu:kurzovni-listek",
    "href": "/kurzovni-listek"
  }, {
    "key": "hu:mallpay",
    "href": "/mallpay"
  }, {
    "key": "hu:mobilni-aplikace",
    "href": "/mobile-app"
  }, {
    "key": "hu:nase-produkty",
    "href": "/nase-produkty"
  }, {
    "key": "hu:nakup-na-splatky",
    "href": "/nakup-na-splatky"
  }, {
    "key": "hu:nakup-na-tretinu",
    "href": "/pay-in-three"
  }, {
    "key": "hu:nakupujte-s-rozumem",
    "href": "/nakupujte-s-rozumem"
  }, {
    "key": "hu:napsali-o-nas",
    "href": "/napsali-o-nas"
  }, {
    "key": "hu:nastaveni-soukromi",
    "href": "/privacy-settings"
  }, {
    "key": "hu:o-skippay",
    "href": "/about-skippay"
  }, {
    "key": "hu:odhlaseni-novinek/token",
    "href": "/unsubscribe-newsletter/[token]"
  }, {
    "key": "hu:odlozena-platba",
    "href": "/odlozena-platba"
  }, {
    "key": "hu:odlozeni-splatnosti",
    "href": "/odlozeni-splatnosti"
  }, {
    "key": "hu:odmeny",
    "href": "/odmeny"
  }, {
    "key": "hu:openapi",
    "href": "/openapi"
  }, {
    "key": "hu:partneri",
    "href": "/partners"
  }, {
    "key": "hu:ostatni-dokumenty",
    "href": "/other-documents"
  }, {
    "key": "hu:platba-kartou",
    "href": "/platba-kartou"
  }, {
    "key": "hu:platba-online",
    "href": "/platba-online"
  }, {
    "key": "hu:platba-skip-pay",
    "href": "/platba-skip-pay"
  }, {
    "key": "hu:platebni-brana",
    "href": "/platebni-brana"
  }, {
    "key": "hu:pojisteni/index",
    "href": "/pojisteni"
  }, {
    "key": "hu:pojisteni/pojistne-podminky",
    "href": "/pojisteni/pojistne-podminky"
  }, {
    "key": "hu:pojisteni-ke-karte",
    "href": "/pojisteni-ke-karte"
  }, {
    "key": "hu:prevod-penez",
    "href": "/prevod-penez"
  }, {
    "key": "hu:pro-eshop",
    "href": "/for-eshop"
  }, {
    "key": "hu:pro-novinare",
    "href": "/for-journalist"
  }, {
    "key": "hu:pro-vyvojare",
    "href": "/for-developers"
  }, {
    "key": "hu:prodlouzena-zaruka",
    "href": "/prodlouzena-zaruka"
  }, {
    "key": "hu:pujcka",
    "href": "/pujcka"
  }, {
    "key": "hu:pujcky",
    "href": "/pujcky"
  }, {
    "key": "hu:recenze-klientu",
    "href": "/recenze-klientu"
  }, {
    "key": "hu:balicek-maxi",
    "href": "/balicek-maxi"
  }, {
    "key": "hu:slevy/index",
    "href": "/slevy"
  }, {
    "key": "hu:slevy/category",
    "href": "/slevy/kategorie/[category]"
  }, {
    "key": "hu:slevy/eshop",
    "href": "/slevy/[eshop]"
  }, {
    "key": "hu:splatky",
    "href": "/splatky"
  }, {
    "key": "hu:srovnavac-produktu/index",
    "href": "/srovnavac-produktu"
  }, {
    "key": "hu:srovnavac-produktu/vyhledavani",
    "href": "/srovnavac-produktu/vyhledavani"
  }, {
    "key": "hu:srovnavac-produktu/category",
    "href": "/srovnavac-produktu/[category]"
  }, {
    "key": "hu:srovnavac-produktu/subcategoryLevelOne",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]"
  }, {
    "key": "hu:srovnavac-produktu/subcategoryLevelTwo",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]"
  }, {
    "key": "hu:srovnavac-produktu/subcategoryLevelThree",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]/[subcategoryLevelThree]"
  }, {
    "key": "hu:srovnavac-produktu/subcategoryLevelFour",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]/[subcategoryLevelThree]/[subcategoryLevelFour]"
  }, {
    "key": "hu:srovnavac-produktu/subcategoryLevelFive",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]/[subcategoryLevelThree]/[subcategoryLevelFour]/[subcategoryLevelFive]"
  }, {
    "key": "hu:srovnavac-produktu/subcategoryLevelSix",
    "href": "/srovnavac-produktu/[category]/[subcategoryLevelOne]/[subcategoryLevelTwo]/[subcategoryLevelThree]/[subcategoryLevelFour]/[subcategoryLevelFive]/[subcategoryLevelSix]"
  }, {
    "key": "hu:sprava-osobnich-udaju/index",
    "href": "/personal-data-management"
  }, {
    "key": "hu:sprava-osobnich-udaju/token",
    "href": "/personal-data-management/[token]"
  }, {
    "key": "hu:tiskove-zpravy/index",
    "href": "/tiskove-zpravy"
  }, {
    "key": "hu:tiskove-zpravy/pressRelease",
    "href": "/tiskove-zpravy/[pressRelease]"
  }, {
    "key": "hu:uvitaci-video",
    "href": "/uvitaci-video"
  }, {
    "key": "hu:vseobecne-obchodni-podminky",
    "href": "/terms-and-conditions"
  }, {
    "key": "hu:whistleblowing",
    "href": "/whistleblowing"
  }, {
    "key": "hu:zaplatim-po-vanocich",
    "href": "/zaplatim-po-vanocich"
  }, {
    "key": "hu:my-to-platime",
    "href": "/my-to-platime"
  }, {
    "key": "hu:zruseni-skip-pay",
    "href": "/zruseni-skip-pay"
  }, {
    "key": "hu:vraceni-preplatku/index",
    "href": "/vraceni-preplatku"
  }, {
    "key": "hu:vraceni-preplatku/token",
    "href": "/vraceni-preplatku/[token]"
  }, {
    "key": "hu:hlaseni-skody",
    "href": "/hlaseni-skody"
  }, {
    "key": "cs:whistleblowing",
    "href": "/cs/whistleblowing"
  }, {
    "key": "sk:whistleblowing",
    "href": "/sk/whistleblowing"
  }, {
    "key": "hu:whistleblowing",
    "href": "/whistleblowing"
  }],
  meta: [{
    "key": "cs:whistleblowing",
    "data": {}
  }, {
    "key": "sk:whistleblowing",
    "data": {}
  }, {
    "key": "hu:whistleblowing",
    "data": {}
  }]
});

// @ts-ignore
export const getStaticProps: GetStaticProps = async context => __root.getStaticProps({
  ...context,
  __locale: 'hu'
});
export default WhistleblowingPage;